import type { Location } from './location-select.types';

const toLocationText = (
	data: (string | null | undefined)[],
	separator = ', ',
) => {
	return data.filter(Boolean).join(separator);
};

/**
 * Get default formatted location.
 */
export function getFormattedLocation(location: Location): string {
	if (location.kma) {
		return `${location.kma} - ${location.address ?? ''}`;
	}

	if (location.address) {
		return location.address;
	}

	if (location.city) {
		return toLocationText([
			location.city,
			toLocationText([location.state, location.zipcode], ' '),
			location.country,
		]);
	}

	if (location.zipcode) {
		return toLocationText([location.zipcode, location.country]);
	}

	if (location.zip3) {
		return toLocationText([location.zip3, location.country]);
	}

	if (location.state) {
		return toLocationText([location.state, location.country]);
	}

	if (location.country) {
		return location.country;
	}

	return 'All Countries';
}

const locationAdapter = {
	getKey(location: Location): string {
		// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we don't want to accept empty strings
		const key = location.kma || location.place_id || location.address;

		return key ? key : getFormattedLocation(location);
	},
	getLabel(location: Location): string {
		return getFormattedLocation(location);
	},
};

export default locationAdapter;
